<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:60px; padding-left:10px;">
            <el-button type="text">
              查询条件
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData()"
            >
              搜索
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @dblclick="viewFun(arguments)"
        @view="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogViewTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 定义表头颜色，高度，搜索，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 查看
import ViewDialog from './components/viewDialog'
// 活动派工API
import { loadActivityReportImageChangeRecordListDataApi, exportActivityReportImageChangeRecordListDataApi } from '@/api/v2/activityReportImageChangeRecord';

export default {
  name: 'ActivityReportImageChangeRecordView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    ViewDialog,
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'activity_report_image_change_record_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['activity_report_image_change_record_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['activity_report_image_change_record_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          schemeNo: '',
          searchDate: 'month'
        }
      },
      id: null,
      eventType: '',
      dialogViewTitle: '查看活动照片修改记录',
      dialogViewVisible: false,
    }
  },
  created () {
    let _this = this;
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'provinceName', label: '省区', filterColumn: 'tcbs.province_name', width: 80 },
      { prop: 'cityName', label: '城市', filterColumn: 'tcbs.city_name', width: 80 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 300 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 190 },
      { prop: 'sellId', label: '活动报告编号', filterColumn: 'taricr.sell_id', width: 140 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tcbs.activity_date', width: 110, isBetween: true },
      { prop: 'realFieldTypeValue', label: '活动场次', filterColumn: '(case tcbs.real_field_type when 1 then \'一场半天\' when 2 then \'一场一天\' else \'\' end)', width: 110 },
      { prop: 'executorName', label: '执行人', filterColumn: 'tcbs.executor_name', width: 120 },
      { prop: 'partnerNames', label: '参与者', filterColumn: 'tcbs.partner_names', width: 120 },
      { prop: 'storeNames', label: '活动场所', filterColumn: 'tcbs.store_names', width: 160 },
      { prop: 'changeUserName', label: '修改人', filterColumn: 'taricr.change_user_name', width: 100 },
      { prop: 'changeTime', label: '修改时间', filterColumn: 'taricr.change_time', width: 160, isBetween: true },
      { prop: 'changeTypeValue', label: '修改照片类型', filterColumn: '(case taricr.change_type when 1 then \'云相机\' when 2 then \'签到签退\' when 3 then \'其他\' else \'\' end)', width: 140 },
      { prop: 'changeContent', label: '修改内容', filterColumn: 'taricr.change_content', width: 300 }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadActivityReportImageChangeRecordListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        let dataList = data.list || [];
        _this.handleData(dataList)
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的数据', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportActivityReportImageChangeRecordListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
